import { useState, useEffect } from 'react'
import { Settings, X, Check, Shield } from 'lucide-react'
import { gsap } from 'gsap'
import styles from './CookieConsent.module.css'

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const [consents, setConsents] = useState({
    essential: true,
    analytics: false,
    marketing: false
  })

  useEffect(() => {
    const hasConsented = localStorage.getItem('nexcom_cookie_consent')
    if (!hasConsented) {
      setTimeout(() => setShowBanner(true), 2000)
    }
  }, [])

  const handleAcceptAll = () => {
    const allConsents = { essential: true, analytics: true, marketing: true }
    setConsents(allConsents)
    saveConsent(allConsents)
  }

  const handleAcceptSelected = () => {
    saveConsent(consents)
  }

  const saveConsent = (data) => {
    localStorage.setItem('nexcom_cookie_consent', JSON.stringify(data))
    setShowBanner(false)
    setShowSettings(false)
  }

  return (
    <>
      {/* Floating Icon */}
      <button 
        className={styles.floatingIcon} 
        onClick={() => setShowBanner(true)}
        aria-label="Cookie Settings"
      >
        <img src="/src/assets/Icons/Cookie.svg" alt="Cookie" className={styles.cookieSvg} />
      </button>

      {/* Main Banner */}
      {showBanner && (
        <div className={styles.overlay}>
          <div className={styles.banner}>
            <div className={styles.bannerHeader}>
              <div className={styles.iconBox}><Shield size={24} /></div>
              <h3>Cookie Preferences</h3>
            </div>
            <p className={styles.bannerText}>
              We use cookies to enhance your experience, analyze site traffic, and serve personalized ads. 
              By clicking "Accept All", you consent to our use of cookies.
            </p>
            <div className={styles.bannerActions}>
              <button className={styles.settingsBtn} onClick={() => setShowSettings(true)}>
                <Settings size={16} /> Settings
              </button>
              <div className={styles.mainBtns}>
                <button className={styles.rejectBtn} onClick={() => saveConsent({ essential: true, analytics: false, marketing: false })}>Reject All</button>
                <button className={styles.acceptBtn} onClick={handleAcceptAll}>Accept All</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Settings Popup */}
      {showSettings && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <button className={styles.closeBtn} onClick={() => setShowSettings(false)}><X size={20} /></button>
            <h2>Cookie Settings</h2>
            <p className={styles.modalDesc}>Manage your privacy preferences for this website.</p>
            
            <div className={styles.optionsList}>
              <div className={styles.optionItem}>
                <div className={styles.optionInfo}>
                  <h4>Essential Cookies</h4>
                  <p>Required for basic site functionality. Cannot be disabled.</p>
                </div>
                <div className={styles.toggleLocked}><Check size={16} /></div>
              </div>

              <div className={styles.optionItem}>
                <div className={styles.optionInfo}>
                  <h4>Analytics Cookies</h4>
                  <p>Help us understand how visitors interact with our site.</p>
                </div>
                <button 
                  className={`${styles.toggle} ${consents.analytics ? styles.toggleActive : ''}`}
                  onClick={() => setConsents({...consents, analytics: !consents.analytics})}
                >
                  <div className={styles.toggleThumb} />
                </button>
              </div>

              <div className={styles.optionItem}>
                <div className={styles.optionInfo}>
                  <h4>Marketing Cookies</h4>
                  <p>Used to deliver personalized advertisements.</p>
                </div>
                <button 
                  className={`${styles.toggle} ${consents.marketing ? styles.toggleActive : ''}`}
                  onClick={() => setConsents({...consents, marketing: !consents.marketing})}
                >
                  <div className={styles.toggleThumb} />
                </button>
              </div>
            </div>

            <button className={styles.saveBtn} onClick={handleAcceptSelected}>Save My Preferences</button>
          </div>
        </div>
      )}
    </>
  )
}
